import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

const Interaction = ({ interaction, isSaved, isMap, optionalInteractionStyle, hideText }) => {
  const iconClass = `ico ico-md icon-${isSaved ? 'full' : 'empty'}-heart`;
  if (interaction && !isMap) {
    return (
      <button className="btn-link no-gutter interaction-wrapper fav-heart favorites-icon" style={ optionalInteractionStyle } onClick={ interaction }>
        <i className={ iconClass } style={{ fontSize: '24px' }} />
        {
          !hideText &&
          <FormattedMessage
            id="shared_components.interaction.save"
            defaultMessage="Save"
          />
        }
      </button>
    );
  }

  return null;
};

Interaction.propTypes = {
  interaction: PropTypes.func,
  isSaved: PropTypes.bool,
  isMap: PropTypes.bool,
  optionalInteractionStyle: PropTypes.object,
  hideText: PropTypes.bool
};

Interaction.defaultProps = {
  isSaved: false,
  isMap: false,
  optionalInteractionStyle: {},
  hideText: false
};

export default Interaction;
